export default __webpack_public_path__ + "static/media/address_image_mobile.bf180411.png";